import React from 'react';
import { Tooltip, IconButton, Typography } from '@mui/material';
import HelpOutline from '@mui/icons-material/HelpOutline';

const DEFAULT_ACCENT = '#4ce1b6';

/**
 * Compact (?) help control for Dynamic Pricing and similar dense forms.
 */
export const ConfigHelpTip = React.memo(function ConfigHelpTip({
  title,
  ariaLabel = 'Explain this setting',
  accentColor = DEFAULT_ACCENT,
}) {
  return (
    <Tooltip
      title={<Typography variant="body2" component="span" sx={{ display: 'block', maxWidth: 300, lineHeight: 1.45 }}>{title}</Typography>}
      placement="top"
      arrow
      enterTouchDelay={0}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'grey.900',
            color: 'common.white',
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: 3,
            '& .MuiTooltip-arrow': { color: 'grey.900' },
          },
        },
      }}
    >
      <IconButton size="small" aria-label={ariaLabel} sx={{ p: 0.35, color: 'text.secondary', '&:hover': { color: accentColor } }}>
        <HelpOutline sx={{ fontSize: 18 }} />
      </IconButton>
    </Tooltip>
  );
});
